var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 123,
    viewBox: "0 0 112 123",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.9294 121.854H11.4723C5.68901 121.854 1.00854 116.959 1.00854 110.93V20.256C1.00854 14.2184 5.6977 9.33203 11.4723 9.33203H95.9294C101.713 9.33203 106.393 14.2274 106.393 20.256V110.93C106.393 116.968 101.713 121.854 95.9294 121.854Z",
    fill: "white",
    stroke: "#282750",
    strokeWidth: 0.953327,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8092 9.33203H12.5925C6.19267 9.33203 1.00854 14.7442 1.00854 21.4255V42.9834H106.393V21.4255C106.393 14.7442 101.209 9.33203 94.8092 9.33203Z",
    fill: "#F57F60",
    stroke: "#282750",
    strokeWidth: 0.953327,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.202 121.854H15.7364C9.95305 121.854 5.27258 116.959 5.27258 110.93V20.256C5.27258 14.2184 9.96174 9.33203 15.7364 9.33203H100.193C105.977 9.33203 110.657 14.2274 110.657 20.256V110.93C110.666 116.968 105.977 121.854 100.202 121.854Z",
    fill: "white",
    stroke: "#282750",
    strokeWidth: 0.953327,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0732 9.33203H16.8566C10.4567 9.33203 5.27258 14.7442 5.27258 21.4255V42.9834H110.666V21.4255C110.666 14.7442 105.473 9.33203 99.0732 9.33203Z",
    fill: "#F57F60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.073 9.33203H16.8564C13.6 9.33203 10.6562 10.7372 8.55481 13.0036C10.526 11.3899 13.0008 10.4199 15.6928 10.4199H98.6388C104.631 10.4199 109.493 15.4966 109.493 21.7519V42.9834H110.657V21.4255C110.666 14.7442 105.473 9.33203 99.073 9.33203Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0732 9.33203H16.8566C10.4567 9.33203 5.27258 14.7442 5.27258 21.4255V42.9834H110.666V21.4255C110.666 14.7442 105.473 9.33203 99.0732 9.33203Z",
    stroke: "#282750",
    strokeWidth: 0.953327,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.895 21.8908C27.8277 21.8908 29.3945 20.2551 29.3945 18.2374C29.3945 16.2197 27.8277 14.584 25.895 14.584C23.9623 14.584 22.3955 16.2197 22.3955 18.2374C22.3955 20.2551 23.9623 21.8908 25.895 21.8908Z",
    fill: "#282750"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9329 21.8908C43.8656 21.8908 45.4324 20.2551 45.4324 18.2374C45.4324 16.2197 43.8656 14.584 41.9329 14.584C40.0001 14.584 38.4333 16.2197 38.4333 18.2374C38.4333 20.2551 40.0001 21.8908 41.9329 21.8908Z",
    fill: "#282750"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9631 21.8908C59.8959 21.8908 61.4626 20.2551 61.4626 18.2374C61.4626 16.2197 59.8959 14.584 57.9631 14.584C56.0304 14.584 54.4636 16.2197 54.4636 18.2374C54.4636 20.2551 56.0304 21.8908 57.9631 21.8908Z",
    fill: "#282750"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0014 21.8908C75.9342 21.8908 77.501 20.2551 77.501 18.2374C77.501 16.2197 75.9342 14.584 74.0014 14.584C72.0687 14.584 70.502 16.2197 70.502 18.2374C70.502 20.2551 72.0687 21.8908 74.0014 21.8908Z",
    fill: "#282750"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0405 21.8908C91.9733 21.8908 93.54 20.2551 93.54 18.2374C93.54 16.2197 91.9733 14.584 90.0405 14.584C88.1078 14.584 86.541 16.2197 86.541 18.2374C86.541 20.2551 88.1078 21.8908 90.0405 21.8908Z",
    fill: "#282750"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1 110.668H5.30708C5.30708 110.668 5.81941 113.478 5.9844 113.941C6.14939 114.394 8.46793 118.138 8.86737 118.519C9.25814 118.89 14.0081 120.912 13.6434 121.383C13.2787 121.855 12.5927 121.864 12.5927 121.864C12.5927 121.864 2.9625 123.142 1 110.668Z",
    fill: "#282750"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3234 28.5078H23.1529L23.6652 31.0099C23.891 32.1431 24.2383 33.7477 24.3946 34.7812H24.4293C24.5596 33.9381 24.8462 32.2791 25.1327 30.9465L25.6537 28.5078H29.4137V37.4102H27.1386V33.8928C27.1386 32.7142 27.1473 31.8349 27.1994 30.747H27.156C26.965 31.6898 26.826 32.5783 26.5482 33.6752L25.6624 37.4193H23.1702L22.2497 33.6843C21.9545 32.4876 21.7982 31.5901 21.6419 30.747H21.5898C21.6245 31.8439 21.6506 32.6508 21.6506 33.8565V37.4193H19.3234V28.5078Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5993 32.9679C39.5993 35.8417 37.7758 37.5732 35.0057 37.5732C32.2877 37.5732 30.4468 35.8417 30.4468 32.9679C30.4468 30.1394 32.3051 28.3535 35.0144 28.3535C37.741 28.3535 39.5993 30.1394 39.5993 32.9679ZM37.0203 32.9679C37.0203 31.2908 36.3517 30.2392 35.0144 30.2392C33.6771 30.2392 32.9998 31.3089 32.9998 32.977C32.9998 34.5725 33.6771 35.6332 35.0144 35.6332C36.3517 35.6332 37.0203 34.5997 37.0203 32.9679Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4045 37.4102C41.5448 34.8084 40.2684 30.7017 39.5997 28.5078H42.1006L42.9342 31.436C43.3076 32.7414 43.6637 34.0469 43.9329 35.307H43.9676C44.2628 34.065 44.6449 32.6961 45.0617 31.2819L45.8693 28.5078H48.3007C47.5366 31.019 45.4612 37.3014 45.4178 37.4102H42.4045Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3922 37.4102H48.9V28.5078H51.3922V37.4102Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5959 37.4102H57.4872L55.9589 33.9018C55.4813 32.823 55.2989 32.2247 55.0731 31.4632H55.0384C55.0731 32.3607 55.0818 33.0225 55.0818 34.0378V37.4102H52.8414V28.5078H56.0631L57.218 31.2819C57.6869 32.3879 58.0863 33.4939 58.3729 34.3098C58.3816 34.3098 58.399 34.3007 58.4076 34.3007C58.3555 33.4123 58.3469 32.7233 58.3469 31.6898V28.5169H60.5872V37.4102H60.5959Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3257 37.41C68.3257 36.9114 68.3344 36.712 68.3344 36.576C67.8828 37.0474 67.0492 37.5732 65.738 37.5732C63.4021 37.5732 61.6479 35.8779 61.6479 32.9679C61.6479 30.1394 63.5062 28.3535 66.1895 28.3535C68.5427 28.3535 69.9235 29.523 70.4619 31.4811H67.9349C67.6397 30.7015 67.0839 30.2482 66.2156 30.2482C64.8696 30.2482 64.2009 31.2817 64.2009 32.9588C64.2009 34.6541 64.9043 35.6604 66.2763 35.6604C67.5442 35.6604 68.0131 34.8626 68.1694 34.3005C67.7526 34.3368 67.466 34.3277 67.0752 34.3277H65.738V32.4149H70.4358V37.4191H68.3257V37.41Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0377 28.5078H76.7904C77.1812 28.5078 77.6154 28.5078 78.0322 28.5169C80.5591 28.6166 82.183 30.194 82.183 32.9227C82.183 34.4911 81.4796 35.996 80.4549 36.6668C79.439 37.2924 78.3448 37.4011 76.7817 37.4011H74.0377V28.5078ZM76.5038 35.4067H77.1378C77.5893 35.4067 77.9714 35.3523 78.284 35.2526C79.1871 34.9625 79.63 34.2463 79.63 32.9409C79.63 31.708 79.1871 30.9465 78.2927 30.6473C78.0061 30.5476 77.6501 30.5022 77.2333 30.5022H76.5038V35.4067Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0802 37.4102C82.8704 35.1076 84.0861 31.708 85.2324 28.5078H88.1414C89.14 31.4451 90.2515 34.5545 91.2501 37.4102H88.7318C88.4974 36.7484 88.315 36.2136 88.0893 35.5336H85.1542L84.5203 37.4102H82.0802ZM87.4901 33.6117C87.2035 32.6689 86.8822 31.5357 86.6304 30.4388H86.5956C86.3699 31.4813 86.0312 32.6689 85.7447 33.6117H87.4901Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8927 28.5078L96.2602 31.8167L95.14 34.0741V37.4102H92.6565V34.0741L91.6926 32.0434C91.1455 30.9102 90.4769 29.496 89.9733 28.5078H92.5523C93.0386 29.6863 93.5075 30.8649 93.9678 31.9981H93.9938C94.3759 30.9374 94.7232 30.1215 95.3918 28.5078H97.8927Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7233 9.65135C19.7233 5.42679 22.3197 2 25.5153 2C28.7108 2 31.3072 5.42679 31.3072 9.65135C31.3072 13.8759 28.7108 17.3027 25.5153 17.3027",
    stroke: "#282750",
    strokeWidth: 3.81331,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1439 9.65135C36.1439 5.42679 38.7403 2 41.9359 2C45.1315 2 47.7279 5.42679 47.7279 9.65135C47.7279 13.8759 45.1315 17.3027 41.9359 17.3027",
    stroke: "#282750",
    strokeWidth: 3.81331,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5542 9.65135C52.5542 5.42679 55.1506 2 58.3462 2C61.5418 2 64.1382 5.42679 64.1382 9.65135C64.1382 13.8759 61.5418 17.3027 58.3462 17.3027",
    stroke: "#282750",
    strokeWidth: 3.81331,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9673 9.65135C68.9673 5.42679 71.5637 2 74.7593 2C77.9548 2 80.5513 5.42679 80.5513 9.65135C80.5513 13.8759 77.9548 17.3027 74.7593 17.3027",
    stroke: "#282750",
    strokeWidth: 3.81331,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3875 9.65135C85.3875 5.42679 87.9838 2 91.1794 2C94.375 2 96.9714 5.42679 96.9714 9.65135C96.9714 13.8759 94.375 17.3027 91.1794 17.3027",
    stroke: "#282750",
    strokeWidth: 3.81331,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1202 67.0426V53.2462H52.2952V67.0426H39.1202Z",
    stroke: "#282750",
    strokeWidth: 0.953327
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5741 67.0426V53.2462H75.749V67.0426H62.5741Z",
    stroke: "#282750",
    strokeWidth: 0.953327
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0299 67.0426V53.2462H99.2048V67.0426H86.0299Z",
    stroke: "#282750",
    strokeWidth: 0.953327
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6573 89.1226V75.3263H28.8323V89.1226H15.6573Z",
    stroke: "#282750",
    strokeWidth: 0.953327
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1202 89.1226V75.3263H52.2952V89.1226H39.1202Z",
    stroke: "#282750",
    strokeWidth: 0.953327
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5755 89.1226V75.3263H75.7505V89.1226H62.5755Z",
    stroke: "#282750",
    strokeWidth: 0.953327
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0304 89.1226V75.3263H99.2053V89.1226H86.0304Z",
    stroke: "#282750",
    strokeWidth: 0.953327
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6573 111.214V97.4181H28.8323V111.214H15.6573Z",
    stroke: "#282750",
    strokeWidth: 0.953327
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1202 111.214V97.4181H52.2952V111.214H39.1202Z",
    stroke: "#282750",
    strokeWidth: 0.953327
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5755 111.214V97.4181H75.7505V111.214H62.5755Z",
    stroke: "#282750",
    strokeWidth: 0.953327
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5056 94.2656C82.0834 90.0488 87 82.114 84.487 76.5425C81.9741 70.9711 72.9833 69.8728 64.4055 74.0896C55.8277 78.3063 50.9111 86.2412 53.4241 91.8126C55.937 97.3841 64.9278 98.4823 73.5056 94.2656Z",
    stroke: "#F57F60",
    strokeWidth: 0.953327,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M65.389 91.0555L75.627 77.0039",
    stroke: "#F57F60",
    strokeWidth: 3.81331,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8711 78.3008L77.1484 89.7597",
    stroke: "#F57F60",
    strokeWidth: 3.81331,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.acadc3758cc48a1336fc2d77b7c298a1.svg";
export { ForwardRef as ReactComponent };